import { MODULE_REQUEST } from '../actions';

export default function(state=null, action){
  switch (action.type) {
    case MODULE_REQUEST:
      return action.payload.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modulo_reducer.js